import * as React from 'react';
import { useState, useEffect } from 'react';
import { inject } from 'mobx-react';
import { UitkLoadingBar, UitkLoadingBarType } from 'uitk-react-loading-bar';
import { ListingsStore, SearchCriteriaStore } from 'stores';

const percInterval = 100;

interface LoadingBarProps {
  listingsStore?: ListingsStore;
  searchCriteriaStore?: SearchCriteriaStore;
}

export const ListingLoadingBar = inject(
  'listingsStore',
  'searchCriteriaStore'
)(({ listingsStore: { progressBarDetails, loading }, searchCriteriaStore }: LoadingBarProps) => {
  const [progress, setProgress] = useState(0);

  const loadingTime =
    searchCriteriaStore &&
    searchCriteriaStore.searchCriteria &&
    ((searchCriteriaStore.searchCriteria.searchFilterValuesList &&
      searchCriteriaStore.searchCriteria.searchFilterValuesList.length > 0) ||
      searchCriteriaStore.searchCriteria.sortOption)
      ? progressBarDetails.sortAndFilterLatency
      : progressBarDetails.listingsLatency;
  const intervalInMS = loadingTime / percInterval;

  useEffect(() => {
    if (loading) {
      setProgress(0);
    } else {
      setProgress(100);
    }

    const interval = setInterval(() => {
      setProgress(progress => progress + 100 / percInterval);
    }, intervalInMS);

    return () => clearInterval(interval);
  }, [intervalInMS, loading]);

  return (
    <div className="loader-spacing">
      <UitkLoadingBar percentLoaded={progress} type={UitkLoadingBarType.PERCENTAGE_CONTROL} />
    </div>
  );
});
